import { locale } from "@/lib/i18n";

export function advertisementDate(value) {
  return value ? new Date(value).toLocaleString(locale(), { timeZone: "Asia/Kolkata" }) : "—";
}
